import { useId } from 'react'

export const Rectangle = ({
  discount,
  props,
}: {
  discount?: string
  props?: React.SVGProps<SVGSVGElement>
}) => {
  const id = useId()
  const paint0Id = `paint0_linear_${id.replace(/:/g, '_')}`
  const paint1Id = `paint1_linear_${id.replace(/:/g, '_')}`
  const textGradientId = `textGradient_${id.replace(/:/g, '_')}`

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none"
      {...props}
    >
      <defs>
        <linearGradient
          id={paint0Id}
          x1="26.5004"
          y1="26.1011"
          x2="9.50005"
          y2="9.10078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="33.0366"
          y1="20.5649"
          x2="-1.96338"
          y2="13.0649"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.139423" stopColor="white" stopOpacity="0" />
          <stop offset="0.427885" stopColor="white" />
          <stop offset="0.721154" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={textGradientId}
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#000000" />
          <stop offset="100%" stopColor="#7F7F7F" />
        </linearGradient>
      </defs>
      <g opacity="0.8">
        <path
          d="M52.6016 -0.000163995L0.399131 52.2023L-0.000101344 18.6009L18.601 -0.00016408L52.6016 -0.000163995Z"
          fill={`url(#${paint0Id})`}
        />
        <path
          d="M52.6016 -0.000163995L0.399131 52.2023L-0.000101344 18.6009L18.601 -0.00016408L52.6016 -0.000163995Z"
          fill={`url(#${paint1Id})`}
        />
      </g>
      {discount && (
        <g transform="translate(0, 37) rotate(-45)">
          <text
            x="26.5"
            y="0"
            textAnchor="middle"
            dominantBaseline="central"
            fill="#4F4F4F"
            fontFamily="Overpass Mono, monospace"
            fontSize="11"
            fontWeight={600}
            letterSpacing="-0.55"
            style={{
              fontFeatureSettings: "'liga' off",
              textShadow: '0 1px 0 rgba(255, 255, 255, 0.3)',
            }}
          >
            {discount}
          </text>
        </g>
      )}
    </svg>
  )
}

export default Rectangle
